const IS_LOADING = "lists/CAMPAIGN_TARGET_TYPE/IS_LOADING";
const IS_ERROR = "lists/CAMPAIGN_TARGET_TYPE/IS_ERROR";
const DATA = "lists/CAMPAIGN_TARGET_TYPE/DATA";
const CAMPAIGN_TARGET_TYPE_EDIT = "lists/CAMPAIGN_TARGET_TYPE/CAMPAIGN_TARGET_TYPE_EDIT";

export { IS_LOADING, IS_ERROR, DATA, CAMPAIGN_TARGET_TYPE_EDIT };
